import { useEffect, useState } from 'react';
import { useAppSelector } from 'hooks/redux.hooks';
import _ from 'lodash';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { FormHeader1 } from 'theme/elements/Headers';
import { FormCard } from 'theme/elements/Forms';
import FormCreator from 'components/FormCreator';
import { fieldsGroupType, fieldType, validationTypes } from 'components/FormCreator/types';
import { AddBankFields } from 'constants/settings.constants';

export default function NewBankDetailsForm({ bankList, handleChange, invalidFields, inputsData }) {
	const t = useAppSelector(selectTranslations);
	const [availableBanks, setAvailableBanks] = useState([{ value: '', label: '' }]);
	const prefixFields = 'page.settings.bank_accounts.create.';

	useEffect(() => {
		if (bankList) {
			const newBankNames = bankList.map((bank: any) => {
				return { value: bank.id, label: bank.bankName };
			});
			setAvailableBanks(newBankNames);
		}
	}, [bankList]);

	return (
		<FormCard>
			<FormHeader1 title={t(prefixFields + 'bank_account_details.title')} />
			<FormCreator
				initialValidation={invalidFields}
				name="newBank"
				handleChange={handleChange}
				fieldsGroups={[
					{
						type: fieldsGroupType.col,
						fields: [
							{
								type: fieldType.text,
								validation: [validationTypes.requierd],
								props: {
									required: true,
									name: AddBankFields.ACCOUNT_HOLDER_NAME,
									label: t(prefixFields + 'bank_account_details.account_owner_name.text'),
									placeholder: t(
										prefixFields + 'bank_account_details.account_owner_name.placeholder'
									),
									value: inputsData.accountOwnerName,
								},
							},
							{
								type: fieldType.select,
								validation: [validationTypes.requierd],
								props: {
									required: true,
									name: AddBankFields.BANK_NAME,
									label: t(prefixFields + 'bank_account_details.bank_name.text'),
									value: inputsData.bankId,
									options: _.values(availableBanks),
								},
							},
						],
					},
					{
						type: fieldsGroupType.row,
						styleObj: {
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'baseLine',
							width: '100%',
						},
						fields: [
							{
								type: fieldType.text,
								validation: [validationTypes.requierd],
								props: {
									required: true,
									name: AddBankFields.ACCOUNT_NUMBER,
									label: t(prefixFields + 'bank_account_details.account_number.text'),
									placeholder: t(prefixFields + 'bank_account_details.account_number.placeholder'),
									value: inputsData.accountNumber,
								},
							},
							{
								type: fieldType.text,
								validation: [validationTypes.requierd],
								props: {
									required: true,
									name: AddBankFields.BRANCH_NUMBER,
									label: t(prefixFields + 'bank_account_details.bank_branch.text'),
									placeholder: t(prefixFields + 'bank_account_details.bank_branch.placeholder'),
									value: inputsData.branchNumber,
								},
							},
						],
					},
				]}
			/>
		</FormCard>
	);
}
